<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title {{ config.title }}
        p {{ config.content }}
        br
        .columns
          .column.is-3
            .field
              label.label Estatus
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model.number="estatus")
                    option(value="" checked) Selecciona el Estado
                    option(v-for="e in estadosDB" v-show="mostrarReingreso(e.id)" :key="e.id" :value="e.id") {{ e.estado }}
                .icon.is-small.is-left
                  i.fas.fa-tools
          .column.is-4(v-show="verUbicacion")
            .field
              label.label Ubicación
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="ubicacionSel" :disabled="isDisabled")
                    option(value="" checked) Seleccione una Ubicación
                    option(v-for="ubi in ubicaciones" :key="ubi.valor" :value="ubi") {{ ubi.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-map-pin
        .columns
          .column.is-4(v-show="verUbicacion")
            .field
              label.label Oficina
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="oficinaSelected" :disabled="isDisabled")
                    option(value="") Selecciona la Oficina
                    option(v-for="data in oficinasFilter" :value="data" :key="data.clave") {{ data.nombre }}
          .column.is-4(v-show="verUbicacion")
            .field
              label.label Localización
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="localizacionSelected")
                    option(v-for="data in localizacionesFilter" :value="data" :key="data.id") {{ data.localizacion }}
        .columns(v-show="Object.keys(datosFaltantes).length > 0")
          .column.is-12
            .notification
              button.delete(@click="closeNotification")
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(:class="config.classCancel" @click="cerrarModal")
                    | {{ config.textCancel }}
                p.control
                  a.button.is-black.is-rounded(:class="config.classOk" @click="checkForm")
                    | {{ config.textOk }}
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ModalUsoEquipo',
    props: {
      config: {
        type: Object,
        default: ()=> {}
      },
      oficinas: {
        type: Array,
        default: ()=> []
      },
      ubicaciones: {
        type: Array,
        default: ()=> []
      },
      localizaciones: {
        type: Array,
        default: ()=> []
      },
      estadosDB: {
        type: Array,
        default: ()=> []
      },
      origen: {
        type: Object,
        default: ()=> {}
      },
    },
    data() {
      return {
        oficinasFilter: [],
        localizacionesFilter: [],
        ubicacionSel: null,
        oficinaSelected: null,
        localizacionSelected: null,
        estatus: null,
        datosFaltantes: [],
        idUserAlmacen: null,
        userAlmacen: null,
        verUbicacion: false,
        isDisabled: true,
      }
    },
    watch: {
      ubicacionSel() {
        if (this.ubicacionSel) {
          
          this.oficinasFilter = this.oficinas.filter( ofi => ofi.ubicacion === this.ubicacionSel.valor === 'CORP' ? 'CORPORATIVO' : this.ubicacionSel.valor)
          switch (this.ubicacionSel.valor) {
            case 'IRGE':
              this.idUserAlmacen = '1566247215482'
              this.userAlmacen = 'IRGE'
              break
            case 'TPA':
              this.idUserAlmacen = '1565899419222'
              this.userAlmacen = 'TPA'
              break
            case 'CORPO':
              this.idUserAlmacen = '1588283398540'
              this.userAlmacen = 'CORPO'
              break
            case 'EB04':
              this.idUserAlmacen = '1566322725551'
              this.userAlmacen = 'EB04'
              break
            case 'LPGD':
              this.idUserAlmacen = '1566322725551'
              this.userAlmacen = 'EB04'
              break
            case 'EB00':
              this.idUserAlmacen = '1565899419222'
              this.userAlmacen = 'TPA'
              break
            case 'EB01':
              this.idUserAlmacen = '1565899419222'
              this.userAlmacen = 'TPA'
              break
            case 'EB02':
              this.idUserAlmacen = '1566322725551'
              this.userAlmacen = 'EB04'
              break
            case 'EB03':
              this.idUserAlmacen = '1566322725551'
              this.userAlmacen = 'EB04'
              break
            case 'ERM':
              this.idUserAlmacen = '1566322725551'
              this.userAlmacen = 'EB04'
              break
          }
        }
      },

      estatus () {
        if (!this.estatus || this.estatus === '') {
          this.verUbicacion = false
        } else {
          const origen_ubicacion = this.origen.ubicacion === 'CORPORATIVO' ? 'CORPO' : this.origen.ubicacion
          switch (this.estatus) {
            case 6:
              this.ubicacionSel = this.ubicaciones.find( ubi => ubi.valor === origen_ubicacion)
              this.oficinaSelected = this.oficinas.find( ofi => ofi.clave === this.origen.clave)
              this.localizacionesFilter = this.localizaciones.filter( loc => loc.id_oficina == this.oficinaSelected.id)
              this.isDisabled = true
              this.verUbicacion = true
              break
            case 7:
              this.ubicacionSel = null
              this.oficinaSelected = ''
              this.oficinasFilter = null
              this.isDisabled = false
              this.verUbicacion = false
              this.idUserAlmacen = ''
              this.userAlmacen = ''
              break
            case 8:
              this.ubicacionSel = this.ubicaciones.find( ubi => ubi.valor === origen_ubicacion)
              this.oficinaSelected = ''
              this.isDisabled = false
              this.verUbicacion = false
              break
            case 9:
              this.ubicacionSel = this.ubicaciones.find( ubi => ubi.valor === origen_ubicacion)
              this.oficinaSelected = this.oficinas.find( ofi => ofi.clave === this.origen.clave)
              this.localizacionesFilter = this.localizaciones.filter( loc => loc.id_oficina == this.oficinaSelected.id)
              this.isDisabled = true
              this.verUbicacion = true
              break
            case 10:
              this.ubicacionSel = this.ubicaciones.find( ubi => ubi.valor === origen_ubicacion)
              this.oficinaSelected = this.oficinas.find( ofi => ofi.clave === this.origen.clave)
              this.localizacionesFilter = this.localizaciones.filter( loc => loc.id_oficina == this.oficinaSelected.id)
              this.isDisabled = true
              this.verUbicacion = true
              break
            case 11:
              this.ubicacionSel = this.ubicaciones.find ( ubi => ubi.valor === origen_ubicacion )
              this.oficinaSelected = ''
              this.isDisabled = false
              this.verUbicacion = false
              break
            case 12:
              return
              this.ubicacionSel = this.ubicaciones.find ( ubi => ubi.valor === origen_ubicacion )
              this.oficinaSelected = ''
              this.isDisabled = false
              this.verUbicacion = false
              break
          }

          
        }
      }
    },
    methods: {
      cerrarModal () {
        this.$emit('selectNewOffice', 'close')
      },
      
      saveData () {
        if (this.permisos.inventarios == 6) {
          return
        }
        let myObj = {
          estatus: this.estatus,
          oficina: this.oficinaSelected ? this.oficinaSelected.clave : '',
          idUbicacion: this.ubicacionSel ? this.ubicacionSel.id : null,
          ubicacion: this.ubicacionSel ? this.ubicacionSel.valor : null,
          id_localizacion: this.localizacionSelected ? this.localizacionSelected.id : '',
          localizacion: this.localizacionSelected ? this.localizacionSelected.localizacion : '',
          idUserAlmacen: this.idUserAlmacen,
          userAlmacen: this.userAlmacen,
        }
        
        this.limpiarForm()
        this.$emit('selectNewOffice', myObj)
      },
      
      checkForm() {
        this.datosFaltantes = []
        if (this.estatus) {
          this.saveData()
        } else {
          if (!this.estatus) {
            this.datosFaltantes.push('El Estatus es requerido')
          }
        }
      },
      
      limpiarForm() {
        this.estatus = null
        this.oficinaSelected = null
        this.ubicacionSel = null
        this.idUserAlmacen = null
        this.userAlmacen = null
      },
      
      closeNotification() {
        this.datosFaltantes = []
        this.limpiarForm()
      },
      mostrarReingreso(id) {
        if (id == 6) {
          if (this.userLogin.cargo === '331' || this.userLogin.cargo === '332' || this.userLogin.cargo === '321' || this.userLogin.cargo === '323' || this.userLogin.cargo === '324' || this.userLogin.cargo === '002' || this.userLogin.cargo === '372') {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
    },
    computed: {
      ...mapState(['userLogin', 'permisos'])
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/shared/ModalUsoEquipo.vue